var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Button, HR, P } from 'shared-assets/components/Elements';
import colors from 'shared-assets/lib/colors';
import { DateTime } from 'luxon';
import kfetch from '@kareo/kfetch';
import PatientCaseDate from './PatientCaseDate';
var datePickerDefaultValues = {
    startDateError: false,
    endDateError: false,
    rangeError: false,
};
var selectDefaultValue = [
    React.createElement("option", { disabled: true, value: "default", key: "default" }, "Select date type"),
];
var datePickerErrors = [];
var PatientCaseDatesAndTypes = function (_a) {
    var errorDates = _a.errorDates, patientCaseId = _a.patientCaseId, accidentFlag = _a.accidentFlag, otheraccidentFlag = _a.otheraccidentFlag, employmentFlag = _a.employmentFlag, pregnancyFlag = _a.pregnancyFlag, practiceId = _a.practiceId, updatePatientCaseDates = _a.updatePatientCaseDates, isNewCase = _a.isNewCase;
    var ACCIDENT_DATE_TYPE_ID = 12;
    var EMPLOYMENT_DATE_TYPE_ID = 2;
    var PREGNANCY_DATE_TYPE_ID = 7;
    var _b = useState([]), patientCaseDates = _b[0], patientCaseDatesSetter = _b[1];
    var _c = useState([]), conditionDateTypes = _c[0], conditionDateTypesSetter = _c[1];
    var _d = useState(selectDefaultValue), selectOptions = _d[0], selectOptionsSetter = _d[1];
    var _e = useState(1), temporalPatientCaseDateId = _e[0], temporalPatientCaseDateIdSetter = _e[1];
    var _f = useState([]), patientCaseDisabledDatesList = _f[0], patientCaseDisabledDatesListSetter = _f[1];
    var _g = useState(''), accidentDateTypeName = _g[0], accidentDateTypeNameSetter = _g[1];
    var _h = useState(''), employmentDateTypeName = _h[0], employmentDateTypeNameSetter = _h[1];
    var _j = useState(''), pregnancyDateTypeName = _j[0], pregnancyDateTypeNameSetter = _j[1];
    useEffect(function () {
        if (patientCaseId || (isNewCase && !(patientCaseId > 0))) {
            kfetch("/billing-profiles-ui/api/Insurance/patientCase/" + patientCaseId).then(function (res) {
                var tempPatientCaseDates = patientCaseId > 0 ? res.patientCase.patientCaseDates : null;
                var tempConditionDateTypes = res.patientCaseDateTypes;
                if (!!tempPatientCaseDates && tempPatientCaseDates.length !== 0) {
                    // convert epoch time to DateTime
                    tempPatientCaseDates.forEach(function (date) {
                        date.startDate = DateTime.fromMillis(date.startDate);
                        if (date.endDate) {
                            date.endDate = DateTime.fromMillis(date.endDate);
                        }
                        date.dateTypeRequired = false;
                        date.isStartDateRequired = false;
                    });
                    // sort condition date types to work with indexes
                    tempPatientCaseDates.sort(function (a, b) {
                        return a.patientCaseDateId > b.patientCaseDateId
                            ? 1
                            : b.patientCaseDateId > a.patientCaseDateId
                                ? -1
                                : 0;
                    });
                    // get the largest id so we can set it to new dates
                    var counter = tempPatientCaseDates[tempPatientCaseDates.length - 1]
                        .patientCaseDateId + 1;
                    temporalPatientCaseDateIdSetter(counter);
                    patientCaseDatesSetter(tempPatientCaseDates);
                    // default values for dates errors
                    for (var i = 0; i < tempPatientCaseDates.length; i++) {
                        datePickerErrors.push(__assign({}, datePickerDefaultValues));
                    }
                }
                var tempSelectOptions = selectOptions.slice();
                if (tempConditionDateTypes.length !== 0) {
                    tempConditionDateTypes.forEach(function (date, index) {
                        tempSelectOptions.push(React.createElement("option", { value: index, key: date.name }, date.name));
                    });
                    conditionDateTypesSetter(tempConditionDateTypes);
                    selectOptionsSetter(tempSelectOptions);
                }
                var tempAccidentFlag;
                var tempEmploymentFlag;
                var tempPregnancyFlag;
                if (!isNewCase) {
                    tempAccidentFlag =
                        res.patientCase.autoAccidentRelatedFlag ||
                            res.patientCase.otherAccidentRelatedFlag;
                    tempEmploymentFlag = res.patientCase.employmentRelatedFlag;
                    tempPregnancyFlag = res.patientCase.pregnancyRelatedFlag;
                }
                res.patientCaseDateTypes.forEach(function (dateType) {
                    switch (dateType.patientCaseDateTypeId) {
                        case ACCIDENT_DATE_TYPE_ID:
                            accidentDateTypeNameSetter(dateType.name);
                            break;
                        case EMPLOYMENT_DATE_TYPE_ID:
                            employmentDateTypeNameSetter(dateType.name);
                            break;
                        case PREGNANCY_DATE_TYPE_ID:
                            pregnancyDateTypeNameSetter(dateType.name);
                            break;
                        default:
                        // Do nothing.
                    }
                });
                if (!isNewCase) {
                    updateDates(tempPatientCaseDates, tempAccidentFlag, tempEmploymentFlag, tempPregnancyFlag);
                }
            });
        }
    }, [patientCaseId]);
    useEffect(function () {
        updateDates();
    }, [accidentFlag, otheraccidentFlag, employmentFlag, pregnancyFlag]);
    // useEffect hooks that bind react to angular
    useEffect(function () {
        updatePatientCaseDates.setPatientCaseDatesAndTypes(patientCaseDates, conditionDateTypes);
    }, [patientCaseDates, conditionDateTypes]);
    useEffect(function () {
        if (errorDates.length > 0) {
            var tempPatientCaseDates = patientCaseDates.slice();
            for (var i = 0; i < tempPatientCaseDates.length; i++) {
                for (var j = 0; j < errorDates.length; j++) {
                    if (tempPatientCaseDates[i].patientCaseDateId === errorDates[j].dateId) {
                        if (errorDates[j].dateTypeError) {
                            tempPatientCaseDates[i].dateTypeRequired = true;
                        }
                        else {
                            tempPatientCaseDates[i].isStartDateRequired = true;
                        }
                    }
                }
            }
            patientCaseDatesSetter(tempPatientCaseDates);
        }
    }, [errorDates]);
    // date format and range errors
    var handleDatePickerErrors = function (indexDate, error) {
        if (error.endDateError) {
            datePickerErrors[indexDate].endDateError = true;
        }
        else if (error.startDateError) {
            datePickerErrors[indexDate].startDateError = true;
        }
        else if (error.rangeError) {
            datePickerErrors[indexDate].rangeError = true;
        }
        else if (datePickerErrors[indexDate].startDateError &&
            error.startDateError != undefined) {
            datePickerErrors[indexDate].startDateError = false;
        }
        else if (datePickerErrors[indexDate].endDateError &&
            error.endDateError != undefined) {
            datePickerErrors[indexDate].endDateError = false;
        }
        else if (datePickerErrors[indexDate].rangeError &&
            error.rangeError != undefined) {
            datePickerErrors[indexDate].rangeError = false;
        }
        updatePatientCaseDates.setDatePickerErrors(datePickerErrors);
    };
    var handleDateTypeChange = function (indexDate, newType) {
        var newPatientCaseDates = patientCaseDates.slice();
        newPatientCaseDates[indexDate].patientCaseDateTypeId =
            newType.patientCaseDateTypeId;
        newPatientCaseDates[indexDate].patientCaseDateType = {
            patientCaseDateTypeId: newType.patientCaseDateTypeId,
            patientCaseDateTypeName: newType.name,
        };
        newPatientCaseDates[indexDate].modifiedDate = Date.now();
        if (newPatientCaseDates[indexDate].dateTypeRequired) {
            newPatientCaseDates[indexDate].dateTypeRequired = false;
        }
        patientCaseDatesSetter(newPatientCaseDates);
    };
    var handleDateChange = function (indexDate, isStartDate, newDate) {
        var newPatientCaseDates = patientCaseDates.slice();
        if (isStartDate) {
            newPatientCaseDates[indexDate].startDate = newDate;
        }
        else {
            newPatientCaseDates[indexDate].endDate = newDate;
        }
        if (newPatientCaseDates[indexDate].isStartDateRequired && isStartDate) {
            newPatientCaseDates[indexDate].isStartDateRequired = false;
        }
        newPatientCaseDates[indexDate].modifiedDate = Date.now();
        patientCaseDatesSetter(newPatientCaseDates);
    };
    var addDate = function (_patientCaseDateTypeId, _patientCaseDateTypeName, _patientCaseDateListDisabled, _patientCaseDateList) {
        if (_patientCaseDateList === void 0) { _patientCaseDateList = patientCaseDates; }
        var newPatientCaseDateType = {
            patientCaseDateTypeId: _patientCaseDateTypeId,
            patientCaseDateTypeName: _patientCaseDateTypeName,
        };
        var now = Date.now();
        var newPatientCaseDate = {
            createdDate: now,
            createdUserId: 0,
            endDate: undefined,
            isStartDateRequired: false,
            modifiedDate: now,
            modifiedUserId: 0,
            patientCaseDateId: temporalPatientCaseDateId,
            patientCaseDateType: newPatientCaseDateType,
            patientCaseDateTypeId: _patientCaseDateTypeId,
            dateTypeRequired: false,
            patientCaseId: patientCaseId,
            practiceId: practiceId,
            startDate: undefined,
        };
        var newPatientCaseDates = _patientCaseDateList.slice();
        newPatientCaseDates.push(newPatientCaseDate);
        patientCaseDatesSetter(newPatientCaseDates);
        temporalPatientCaseDateIdSetter(temporalPatientCaseDateId + 1);
        if (_patientCaseDateListDisabled) {
            var currentDisabledDates = _patientCaseDateListDisabled.slice();
            currentDisabledDates.push(temporalPatientCaseDateId);
            patientCaseDisabledDatesListSetter(currentDisabledDates);
        }
        datePickerErrors.push(__assign({}, datePickerDefaultValues));
    };
    var updateDates = function (patientCaseDateList, accidentRelatedFlag, employmentRelatedFlag, pregnancyRelatedFlag) {
        if (patientCaseDateList === void 0) { patientCaseDateList = patientCaseDates; }
        if (accidentRelatedFlag === void 0) { accidentRelatedFlag = accidentFlag || otheraccidentFlag; }
        if (employmentRelatedFlag === void 0) { employmentRelatedFlag = employmentFlag; }
        if (pregnancyRelatedFlag === void 0) { pregnancyRelatedFlag = pregnancyFlag; }
        var tmpAccidentFlag = accidentRelatedFlag;
        var tmpEmploymentFlag = employmentRelatedFlag;
        var tmpPregnancyFlag = pregnancyRelatedFlag;
        var newDateList = [];
        var newDateDisabledList = [];
        if (patientCaseDateList) {
            patientCaseDateList.forEach(function (date) {
                if (date.startDate) {
                    newDateList.push(date);
                }
                switch (date.patientCaseDateTypeId) {
                    case ACCIDENT_DATE_TYPE_ID:
                        if (tmpAccidentFlag) {
                            tmpAccidentFlag = false;
                            newDateDisabledList.push(date.patientCaseDateId);
                            if (!date.startDate) {
                                newDateList.push(date);
                            }
                        }
                        break;
                    case EMPLOYMENT_DATE_TYPE_ID:
                        if (tmpEmploymentFlag) {
                            tmpEmploymentFlag = false;
                            newDateDisabledList.push(date.patientCaseDateId);
                            if (!date.startDate) {
                                newDateList.push(date);
                            }
                        }
                        break;
                    case PREGNANCY_DATE_TYPE_ID:
                        if (tmpPregnancyFlag) {
                            tmpPregnancyFlag = false;
                            newDateDisabledList.push(date.patientCaseDateId);
                            if (!date.startDate) {
                                newDateList.push(date);
                            }
                        }
                        break;
                    default:
                        if (!date.startDate) {
                            newDateList.push(date);
                        }
                        break;
                }
            });
            if (tmpAccidentFlag) {
                addDate(ACCIDENT_DATE_TYPE_ID, accidentDateTypeName, newDateDisabledList, newDateList);
            }
            else if (tmpEmploymentFlag) {
                addDate(EMPLOYMENT_DATE_TYPE_ID, employmentDateTypeName, newDateDisabledList, newDateList);
            }
            else if (tmpPregnancyFlag) {
                addDate(PREGNANCY_DATE_TYPE_ID, pregnancyDateTypeName, newDateDisabledList, newDateList);
            }
            else {
                patientCaseDatesSetter(newDateList);
                patientCaseDisabledDatesListSetter(newDateDisabledList);
            }
        }
    };
    var isDisabled = function (dateId) {
        if (patientCaseDisabledDatesList) {
            return patientCaseDisabledDatesList.indexOf(dateId) >= 0;
        }
        return false;
    };
    var getRequiredReason = function (dateTypeId) {
        var reason = "";
        switch (dateTypeId) {
            case ACCIDENT_DATE_TYPE_ID:
                reason = "auto accident or other accident";
                break;
            case EMPLOYMENT_DATE_TYPE_ID:
                reason = "employment";
                break;
            case PREGNANCY_DATE_TYPE_ID:
                reason = "pregnancy";
                break;
            default:
            //do nothing;
        }
        return reason;
    };
    var deleteDate = function (indexDate) {
        var newPatientCaseDates = patientCaseDates.slice();
        newPatientCaseDates.splice(indexDate, 1);
        patientCaseDatesSetter(newPatientCaseDates);
        datePickerErrors.splice(indexDate, 1);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(HR, null),
        React.createElement(P, { style: { color: colors.textColorPrimary, padding: 0 } },
            React.createElement("b", null, "Add events related to condition")),
        patientCaseDates.map(function (date, index) { return (React.createElement(PatientCaseDate, { changeDateCallback: handleDateChange, changeDateTypeCallback: handleDateTypeChange, date: date, dateTypes: conditionDateTypes, deleteDateCallback: deleteDate, handleErrorsCallback: handleDatePickerErrors, indexDate: index, key: date.patientCaseDateId, options: selectOptions, disabled: isDisabled(date.patientCaseDateId), dateTypeReason: getRequiredReason(date.patientCaseDateTypeId) })); }),
        React.createElement(Button, { "data-testid": "add-event-btn", type: "button", className: "link noBtn", style: {
                color: colors.primary,
                padding: '1em',
            }, onClick: function (e) {
                e.preventDefault();
                addDate();
            } }, "Add event")));
};
export default PatientCaseDatesAndTypes;
